export default [{
  // Device Registration page
  component: function component() {
    return import('pages/Register');
  },
  meta: {
    title: 'route.register'
  },
  path: '/register'
}, {
  // Staff page
  component: function component() {
    return import('pages/staff/Staff');
  },
  meta: {
    title: 'route.staff'
  },
  path: '/staff'
}];